export default __webpack_public_path__ + "db87250421b86b050a122c39615a3745.svg";